// feedback apps and areas
export const FEEDBACK_AREAS = {
  HOME_ALL: 'Home_Home',
  HOME_UPCOMING: 'Home_Upcoming',
  HOME_SCHEDULE: 'Home_Schedule',
  HOME_THEMER: 'Home_Themer',
  HOME_CUSTOM_PAGES: 'Home_Custom pages',
  HOME_WIDGETS: 'Home_Widgets',
  HOME_OTHER: 'Home_Other',
  LINKS_ALL: 'Links_Links',
  LINKS_HOME: 'Links_Home',
  LINKS_SEARCH: 'Links_Search',
  LINKS_ALL_LINKS: 'Links_All links',
  LINKS_CATEGORY_PAGES: 'Links_Category pages',
  LINKS_OTHER: 'Links_Other',
  PROFILE_ALL: 'Profile_Profile',
  PROFILE_PROFILE: 'Profile_Portal profile',
  PROFILE_COURSE_PROGRESS: 'Profile_Course progress',
  PROFILE_OTHER: 'Profile_Other',
  ADMIN_ALL: 'Admin_Admin',
  ADMIN_UPDATES: 'Admin_Updates',
  ADMIN_NOTIFICATIONS: 'Admin_Notifications',
};

const HOME_AREAS = [
  FEEDBACK_AREAS.HOME_ALL,
  FEEDBACK_AREAS.HOME_UPCOMING,
  FEEDBACK_AREAS.HOME_SCHEDULE,
  FEEDBACK_AREAS.HOME_THEMER,
  FEEDBACK_AREAS.HOME_CUSTOM_PAGES,
  FEEDBACK_AREAS.HOME_WIDGETS,
  FEEDBACK_AREAS.HOME_OTHER,
];
const HOME_ITEMS = HOME_AREAS.map((appName) => ({
  text: appName.split('_')[1],
  value: appName,
}));

const LINKS_AREAS = [
  FEEDBACK_AREAS.LINKS_ALL,
  FEEDBACK_AREAS.LINKS_HOME,
  FEEDBACK_AREAS.LINKS_SEARCH,
  FEEDBACK_AREAS.LINKS_ALL_LINKS,
  FEEDBACK_AREAS.LINKS_CATEGORY_PAGES,
  FEEDBACK_AREAS.LINKS_OTHER,
];
const LINKS_ITEMS = LINKS_AREAS.map((appName) => ({
  text: appName.split('_')[1],
  value: appName,
}));

const PROFILE_AREAS = [
  FEEDBACK_AREAS.PROFILE_ALL,
  FEEDBACK_AREAS.PROFILE_PROFILE,
  FEEDBACK_AREAS.PROFILE_COURSE_PROGRESS,
  FEEDBACK_AREAS.PROFILE_OTHER,
];
const PROFILE_ITEMS = PROFILE_AREAS.map((appName) => ({
  text: appName.split('_')[1],
  value: appName,
}));

const ADMIN_AREAS = [
  FEEDBACK_AREAS.ADMIN_ALL,
  FEEDBACK_AREAS.ADMIN_UPDATES,
  FEEDBACK_AREAS.ADMIN_NOTIFICATIONS,
];
const ADMIN_ITEMS = ADMIN_AREAS.map((appName) => ({
  text: appName.split('_')[1],
  value: appName,
}));

export const FEEDBACK_APPS_FILTERS = [
  {
    accordionTitle: FEEDBACK_AREAS.HOME_ALL.split('_')[1],
    items: HOME_ITEMS,
  },
  {
    accordionTitle: FEEDBACK_AREAS.LINKS_ALL.split('_')[1],
    items: LINKS_ITEMS,
  },
  {
    accordionTitle: FEEDBACK_AREAS.PROFILE_ALL.split('_')[1],
    items: PROFILE_ITEMS,
  },
  {
    accordionTitle: FEEDBACK_AREAS.ADMIN_ALL.split('_')[1],
    items: ADMIN_ITEMS,
  },
];

// feedback priority
export const FEEDBACK_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  VERY_HIGH: 'very_high',
};

export const PRIORITY_TAGS = {
  [FEEDBACK_PRIORITY.LOW]: {
    label: 'Low',
    colour: 'green',
  },
  [FEEDBACK_PRIORITY.MEDIUM]: {
    label: 'Medium',
    colour: 'blue',
  },
  [FEEDBACK_PRIORITY.HIGH]: {
    label: 'High',
    colour: 'orange',
  },
  [FEEDBACK_PRIORITY.VERY_HIGH]: {
    label: 'Very High',
    colour: 'red',
  },
};

export const PRIORITY_FILTERS = [
  FEEDBACK_PRIORITY.LOW,
  FEEDBACK_PRIORITY.MEDIUM,
  FEEDBACK_PRIORITY.HIGH,
  FEEDBACK_PRIORITY.VERY_HIGH,
];

// feedback status
export const UPDATE_FEEDBACK_STATUS = {
  NEW: 'new',
  DISCUSSION_REQUIRED: 'discussion_required',
  BACKLOG: 'backlog',
  IN_JIRA: 'in_jira',
  REMEDY: 'remedy',
  RESOLVED: 'resolved',
};

export const FEEDBACK_STATUS = {
  [UPDATE_FEEDBACK_STATUS.NEW]: 'New',
  [UPDATE_FEEDBACK_STATUS.DISCUSSION_REQUIRED]: 'Discussion required',
  [UPDATE_FEEDBACK_STATUS.BACKLOG]: 'Backlog',
  [UPDATE_FEEDBACK_STATUS.IN_JIRA]: 'In Jira',
  [UPDATE_FEEDBACK_STATUS.REMEDY]: 'Remedy - BMC',
  [UPDATE_FEEDBACK_STATUS.RESOLVED]: 'Resolved',
};

export const STATUS_FILTERS = [
  {
    text: FEEDBACK_STATUS[UPDATE_FEEDBACK_STATUS.NEW],
    value: UPDATE_FEEDBACK_STATUS.NEW,
  },
  {
    text: FEEDBACK_STATUS[UPDATE_FEEDBACK_STATUS.DISCUSSION_REQUIRED],
    value: UPDATE_FEEDBACK_STATUS.DISCUSSION_REQUIRED,
  },
  {
    text: FEEDBACK_STATUS[UPDATE_FEEDBACK_STATUS.BACKLOG],
    value: UPDATE_FEEDBACK_STATUS.BACKLOG,
  },
  {
    text: FEEDBACK_STATUS[UPDATE_FEEDBACK_STATUS.IN_JIRA],
    value: UPDATE_FEEDBACK_STATUS.IN_JIRA,
  },
  {
    text: FEEDBACK_STATUS[UPDATE_FEEDBACK_STATUS.REMEDY],
    value: UPDATE_FEEDBACK_STATUS.REMEDY,
  },
  {
    text: FEEDBACK_STATUS[UPDATE_FEEDBACK_STATUS.RESOLVED],
    value: UPDATE_FEEDBACK_STATUS.RESOLVED,
  },
];

export const OPT_IN = {
  YES: 'true',
  NO: 'false',
};

export const OPT_IN_FILTERS = [
  {
    text: 'Yes',
    value: OPT_IN.YES,
  },
  {
    text: 'No',
    value: OPT_IN.NO,
  },
];

// sorting
export const SORT_OPTIONS = [
  { text: 'Newest', value: 'newest' },
  { text: 'Oldest', value: 'oldest' },
  { text: 'Lowest priority', value: 'priority_lowest' },
  { text: 'Highest priority', value: 'priority_highest' },
  { text: 'Last updated', value: 'last_updated' },
];

export const PRIORITY_LEVEL = {
  low: 0,
  medium: 1,
  high: 2,
  very_high: 3,
};

export const BUG = {
  YES: 'true',
  NO: 'false',
};

export const BUG_OPTIONS = [
  {
    text: 'Yes',
    value: BUG.YES,
  },
  { text: 'No', value: BUG.NO },
];

export const HDR = {
  YES: 'true',
  NO: 'false',
};

export const HDR_OPTIONS = [
  {
    text: 'Yes',
    value: HDR.YES,
  },
  { text: 'No', value: HDR.NO },
];
